// extracted by mini-css-extract-plugin
module.exports = {"promoPartOne":"az_zsc","promoPartTwo":"az_Asc","promoCode":"az_Bsc"};